import { ErrorChannel, FunctionsErrorCode } from './manageError.util';
import { ErrorCode } from './errorCatalog';

export interface DomainErrorOptions {
  /** Structured error code from the catalog — surfaced to callers via HttpsError.details.customCode */
  readonly customCode?: ErrorCode;
  /** Structured context payload — surfaced to callers via HttpsError.details.context */
  readonly context?: unknown;
  /** Upstream error that triggered this one — preserves the trace chain for debugging */
  readonly cause?: unknown;
}

export class DomainError extends Error {
  readonly statusCode: number;
  readonly time: Date;
  readonly code: FunctionsErrorCode;
  readonly messageToDisplay: string;
  readonly channel: ErrorChannel;
  readonly customCode?: ErrorCode;
  readonly context?: unknown;
  sourceIp?: string;
  userAgent?: string;
  origin?: string;

  constructor(
    message: string,
    code: FunctionsErrorCode,
    statusCode: number,
    channel: ErrorChannel = 'STANDARD',
    options: DomainErrorOptions = {},
  ) {
    super(message);
    this.messageToDisplay = message;
    this.code = code;
    this.statusCode = statusCode;
    this.time = new Date();
    this.channel = channel;
    this.customCode = options.customCode;
    this.context = options.context;
    if (options.cause !== undefined) {
      (this as { cause?: unknown }).cause = options.cause;
    }
  }
}
